import { render, staticRenderFns } from "./joingreen.vue?vue&type=template&id=0108aa99&scoped=true"
import script from "./joingreen.vue?vue&type=script&lang=js"
export * from "./joingreen.vue?vue&type=script&lang=js"
import style0 from "./joingreen.vue?vue&type=style&index=0&id=0108aa99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108aa99",
  null
  
)

export default component.exports